import React from "react";
import {Box, Inline, Text} from "@unibuddy/patron";
import {useTranslation} from "@unibuddy/intl";
import moment from "moment";

import Write from "../../Chat/components/ContentPreview/Icons/Write";
import View from "../../Chat/components/ContentPreview/Icons/View";
import Clock from "../../Chat/components/ContentPreview/Icons/Clock";
import {BlogShareButton} from "./BlogShareButton";

type BlogDetailHeaderProps = {
    modified: string;
    readingTime: string;
    numberOfViews: string;
    space?: string;
    shareUrl?: string;
    onShare?: () => void | Promise<void>;
};

const getLocalTime = (date: string) => {
    return moment.utc(date).local();
};
export const BlogDetailHeader = ({
    modified,
    numberOfViews,
    readingTime,
    space = "medium",
    shareUrl,
    onShare,
}: BlogDetailHeaderProps) => {
    const {t} = useTranslation();
    const parsedReadingTime = parseInt(readingTime, 10);
    const minutesDesc = parsedReadingTime > 1 ? "mins" : "min";
    const modifiedDate = `${getLocalTime(modified).format("MMMM D, YYYY")}`;
    const modifiedDateSplitted = modifiedDate.split(" ");
    const modifiedMonth = modifiedDateSplitted[0];
    const modifiedRestOfDate = modifiedDateSplitted[1].concat(" ").concat(modifiedDateSplitted[2]);

    const iconSize = {
        width: 20,
        height: 20,
    };
    const textStyles = {
        weight: 400,
        align: "center",
        size: "small",
    };
    const inlineStyles = {
        verticalAlign: "center",
        space: "xxsmall",
    };

    return (
        <Inline space={space} verticalAlign={"center"} wrap={"wrap"}>
            <Inline {...inlineStyles}>
                <Box paddingTop={"xxsmall"}>
                    <Write {...iconSize} />
                </Box>
                <Text {...textStyles} data-test-id={"readingTime"}>
                    {`${readingTime} ${t("minuteShort", minutesDesc, {
                        count: parsedReadingTime,
                    })}`}
                </Text>
            </Inline>

            <Inline {...inlineStyles}>
                <Box paddingTop={"xxsmall"}>
                    <View />
                </Box>
                <Text {...textStyles}>{numberOfViews}</Text>
            </Inline>

            <Inline {...inlineStyles}>
                <Box paddingTop={"xxsmall"}>
                    <Clock {...iconSize} />
                </Box>
                <Text {...textStyles} data-test-id={"publishedDate"}>
                    {`${t(
                        `months:${modifiedMonth}.short`,
                        `${getLocalTime(modified).format("MMM")}`,
                    )} ${modifiedRestOfDate}`}
                </Text>
            </Inline>

            <Inline {...inlineStyles}>
                {shareUrl && <BlogShareButton shareUrl={shareUrl} onCopy={onShare} />}
            </Inline>
        </Inline>
    );
};
